import { DirectoryStoreState, Extension, Store } from '../types';
import { getType } from 'typesafe-actions';
import { openStoreExtensions, setExtensionsSearchQuery, setStoreExtensions } from '../actions';
import * as R from 'ramda';
import { createSelector } from 'reselect';
import { nameRegExpTest } from './stores';

const { createReducer } = require('redux-ramda');

export interface Extensions {
  index: Extension[];
  query: string;
  isOpen: boolean;
}

export interface ExtensionsState {
  [key: number]: Extensions;
}
const initialState: ExtensionsState = {};

export const extensions = createReducer(initialState, [
  [
    getType(setStoreExtensions),
    ({ storeId, extensions }: any) =>
      R.pipe(
        R.assocPath([storeId, 'index'], extensions),
        R.assocPath([storeId, 'query'], ''),
        R.assocPath([storeId, 'isOpen'], true)
      ),
  ],
  [
    getType(openStoreExtensions),
    ({ storeId, isOpen }: any) => R.assocPath([storeId, 'isOpen'], isOpen),
  ],
  [
    getType(setExtensionsSearchQuery),
    ({ storeId, searchQuery }: { storeId: number; searchQuery: string }) =>
      R.assocPath([storeId, 'query'], searchQuery),
  ],
]);

export const getExtensionByStoreId = (id: number) => (state: DirectoryStoreState) => {
  return state.extensions[id];
};

export const getFilteredExtensions = (storeId: number) =>
  createSelector<DirectoryStoreState, Extensions['index'], Extensions['query'], Extension[]>(
    state => state.extensions[storeId].index,
    state => state.extensions[storeId].query,
    (extensions, query) => {
      if (extensions.length && query) {
        return extensions.filter(isSearchQuery(query));
      }
      return extensions;
    }
  );

const isSearchQuery = R.curry((searchQuery: string, extension: Extension) => {
  const searchableStr = R.join(' ', R.props(['name', 'code', 'overridden_code'])(extension));
  return nameRegExpTest(searchableStr, R.trim(searchQuery));
});
